module.exports = __webpack_public_path__ + "static/media/sha1.3e81b974.mp4";